(function ($) {
//  alert('bosop');
  var options = {
    // vertical offset in px before element is first unpinned
    // offset : 500,
    // or you can specify offset individually for up/down scroll
    offset: {
        up: 0,
        down: 80
    },
    // or you can specify tolerance individually for up/down scroll
    tolerance : {
        up : 5,
        down : 5
    },
    // css classes to apply
    classes : {
        // when element is initialised
        initial : "ptx-primarynav",
        // when scrolling up
        pinned : "ptx-primarynav--goingup",
        // when scrolling down
        unpinned : "ptx-primarynav--goingdown",
        // when above offset
        top : "ptx-primarynav--top",
        // when below offset
        notTop : "ptx-primarynav--not-top",
        // when at bottom of scroll area
        bottom : "ptx-primarynav--bottom",
        // when not at bottom of scroll area
        notBottom : "ptx-primarynav--not-bottom",
        // when frozen method has been called
        frozen: "ptx-primarynav--frozen",
        // multiple classes are also supported with a space-separated list
        // pinned: "ptx-primarynav--pinned"
    },
    // element to listen to scroll events on, defaults to `window`
    // scroller : someElement,
    // callback when pinned, `this` is headroom object
    onPin : function() {},
    // callback when unpinned, `this` is headroom object
    onUnpin : function() {},
    // callback when above offset, `this` is headroom object
    onTop : function() {},
    // callback when below offset, `this` is headroom object
    onNotTop : function() {},
    // callback when at bottom of page, `this` is headroom object
    onBottom : function() {
      console.log(this);
    },
    // callback when moving away from bottom of page, `this` is headroom object
    onNotBottom : function() {}
};

if(true){
  $(".ptx-primarynav").headroom(options);
}
 
// alert('beep');

/**/
//  mouseenter mouseleave
$( $(".ptx-primarynav") ).on( "mouseenter", function(){
  if($(this).hasClass('ptx-primarynav--hidey')){
    $(".ptx-primarynav").removeClass("ptx-primarynav--goingdown").addClass("ptx-primarynav--goingup");
  }
  
} );


/* HIDE AND SSHOW NAV ON CLICK
$( $(".ptx-primarynav__content") ).on( "click", function(){
  $(".ptx-primarynav").addClass("ptx-primarynav--unpinned").removeClass("ptx-primarynav--pinned");
} );
*/
$( $(".ptx-primarynav__toggle button") ).on( "click", function(){
  $(".ptx-primarynav").removeClass("ptx-primarynav--goingdown").addClass("ptx-primarynav--goingup");
} );



/*

$( $(".ptx-primarynav") ).on( "mouseleave", function(){
  $(".ptx-primarynav").removeClass("ptx-primarynav--pinned").addClass("ptx-primarynav--unpinned");
} );
*/
})(jQuery);
   
   